export const CATALOG_REFERENCE_REQUIRED_FIELDS = [
    'catalog_reference_kunnr',
    'catalog_reference_parnr',
    'catalog_reference_vkorg',
] as const;

const isFilled = (value: unknown): boolean =>
    value !== null && value !== undefined && String(value).trim() !== '';

export const validateCatalogReferenceFields = (
    values: Record<string, unknown>,
    message: string
): Record<string, string> => {
    const filledCount = CATALOG_REFERENCE_REQUIRED_FIELDS.filter(field => isFilled(values[field])).length;

    if (filledCount === 0 || filledCount === CATALOG_REFERENCE_REQUIRED_FIELDS.length) {
        return {};
    }

    const errors: Record<string, string> = {};
    CATALOG_REFERENCE_REQUIRED_FIELDS.forEach(field => {
        if (!isFilled(values[field])) {
            errors[field] = message;
        }
    });

    return errors;
};

export const transformVisitorCountryPayload = (
    data: Record<string, unknown>
): Record<string, unknown> => {
    const merged = {...data};

    CATALOG_REFERENCE_REQUIRED_FIELDS.forEach(field => {
        const value = merged[field];
        merged[field] = isFilled(value) ? String(value).trim() : null;
    });

    merged.catalog_reference_price_group = null;

    return merged;
};
